
/*@jsxRuntime automatic @jsxImportSource react*/
/*prettier-ignore*/
/*prettier-ignore*/
export const attributes = {
  "authors": ["chase-merlin", "ben-milne"],
  "callToAction": {
    "heading": "Get started",
    "subheading": "Create your own stablecoin payments program",
    "button": "Sign up",
    "ctaUrl": "/pricing",
    "externalUrl": true
  },
  "date": "2024-07-18",
  "description": "Stablecoin payments on leading blockchains are now 10X to 1000X cheaper than traditional payment methods. Learn how to support stablecoin payments by creating your own stablecoin.",
  "discussLinkedIn": "https://www.linkedin.com/posts/brale_costs-to-send-1m-on-leading-blockchains-activity-7219732393560092673-cGDD/",
  "discussTwitter": "https://x.com/brale_xyz/status/1813967296253313156",
  "discussFarcaster": "https://warpcast.com/brale/0xd8fa5925",
  "excerpt": "Comparing the cost to send $1M in stablecoins on ten leading blockchains. Stablecoin payments are 10 to 1000 times cheaper than traditional payment methods.",
  "ogImage": {
    "alt": "Costs to send $1M on leading blockchains | Brale Blog",
    "url": "/assets/blog/costs-to-send-1m-on-leading-blockchains/og-image.png"
  },
  "timeOverride": 2,
  "title": "Costs to send $1M on leading blockchains",
  "transfers": [{
    "chainId": "ethereum",
    "name": "Ethereum",
    "cost": "$2.89",
    "transferTxn": "https://etherscan.io/tx/0x58aaf10867bc86584cc4f5e9b819fe4187a5b5e8bac6a832d342d89d959f85df"
  }, {
    "chainId": "avalanche",
    "name": "Avalanche",
    "cost": "$0.07",
    "transferTxn": "https://avascan.info/blockchain/c/tx/0xcd2336c1315dd004debfe29afc70d4a5d085954843eb3c84411d7af8852f0cd4"
  }, {
    "chainId": "optimism",
    "name": "Optimism",
    "cost": "$0.02",
    "transferTxn": "https://avascan.info/blockchain/c/tx/0xcd2336c1315dd004debfe29afc70d4a5d085954843eb3c84411d7af8852f0cd4"
  }, {
    "chainId": "base",
    "name": "Base",
    "cost": "$0.005",
    "transferTxn": "https://basescan.org/tx/0x0dead9fba4c2b357bb4d9c41f2437c04806e13bf3b36f125b57216a1df5e9a04"
  }, {
    "chainId": "arbitrum",
    "name": "Arbitrum",
    "cost": "$0.005",
    "transferTxn": "https://arbiscan.io/tx/0xa8a260fa1661a595cd6be40c7b64e5cf93bf37d5cc28444a7064b14a7b91e992"
  }, {
    "chainId": "ethereum-classic",
    "name": "Ethereum Classic",
    "cost": "$0.003",
    "transferTxn": "https://etc.blockscout.com/tx/0x46e3b33f057ad37b837eee6adf83bcddd5a62b1aa76a94449066abd200dc975e"
  }, {
    "chainId": "polygon",
    "name": "Polygon",
    "cost": "$0.001",
    "transferTxn": "https://polygonscan.com/tx/0xb6bae26d0a11da7dc6c86fc3e9aa270beaa783bfe3133880bb1e1edc22f2b649"
  }, {
    "chainId": "celo",
    "name": "Celo",
    "cost": "$0.0004",
    "transferTxn": "https://celoscan.io/tx/0x9ead926d45702a1e84a861289e57f4f22cd086cee7b1f848c4c550ed70af8359"
  }, {
    "chainId": "solana",
    "name": "Solana",
    "cost": "$0.0002",
    "transferTxn": "https://explorer.solana.com/tx/2gfRmsMBKHXXNom49uFbcChdmfpPDZEvyXoBoKvtA7YY8hXjiHko4utK3Tc4hq8mNV8MbRK5hsyKLQwsJAQALpWs"
  }, {
    "chainId": "stellar",
    "name": "Stellar",
    "cost": "$0.000001",
    "transferTxn": "https://stellar.expert/explorer/public/tx/c851361ff1c349fd4a24bfaa4fc129bcfc295181317a06dbb7040d190db20d62"
  }],
  "fees": {
    "offchain": [{
      "type": "Wire",
      "depositFee": "$0",
      "withdrawFee": "$20",
      "timing": "Same day"
    }, {
      "type": "ACH",
      "depositFee": "$0",
      "withdrawFee": "$0",
      "timing": "Next day"
    }],
    "onchain": [{
      "type": "USDC",
      "depositFee": "$0",
      "withdrawFee": "$0",
      "timing": "Same day"
    }, {
      "type": "USDP",
      "depositFee": "$0",
      "withdrawFee": "$0",
      "timing": "Same day"
    }, {
      "type": "PYUSD",
      "depositFee": "$0",
      "withdrawFee": "$0",
      "timing": "Same day"
    }]
  }
};
import {faArrowUpRight} from "@fortawesome/pro-light-svg-icons";
import {BlockchainIcon} from "~/components/logos/blockchain";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {ExternalLink} from "~/components/site/external-link";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    tr: "tr",
    td: "td",
    h2: "h2"
  }, props.components);
  return <><_components.p>{"We’ve summarized the costs to send $1,000,000 on ten leading blockchains, based on stablecoin transactions conducted at Brale."}</_components.p>{"\n"}<div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 whitespace-nowrap"><thead><tr><th>{"Chain"}</th><th className="px-4">{"Txn Cost"}</th><th className="text-right">{"$1M Txn"}</th></tr></thead><tbody>{attributes.transfers.map(t => <_components.tr key={t.transferTxn}>
          <_components.td>
            <BlockchainIcon chainId={t.chainId} className="mr-2 inline-block" />
            {t.name}
          </_components.td>
          <_components.td className="px-4">{t.cost}</_components.td>
          <_components.td className="text-right align-middle">
            <ExternalLink title="View on explorer" href={t.transferTxn}>
              <FontAwesomeIcon className="h-4 w-4 text-secondary" icon={faArrowUpRight} />
            </ExternalLink>
          </_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.h2>{"Stablecoins are 5X-1000X cheaper than traditional payment methods"}</_components.h2>{"\n"}<_components.p>{"Stablecoin payments on all leading blockchains other than Ethereum mainnet surpass traditional payment method fees, settle nearly instantly, and benefit from 24/7 always on, global operations."}</_components.p>{"\n"}<_components.p>{"Ethereum Layer 2s, Solana, and Stellar are all less than $0.01 per transaction and up to 100X cheaper than ACH, with stablecoin payments on the latter networks approaching the cost of relational database updates. Even payments on Ethereum mainnet are comparable with wire fees but settle globally in less than 5 minutes."}</_components.p>{"\n"}<_components.p>{"The costs of stablecoin payments are low enough that programs on Base, Solana, Stellar, and many blockchains can be effectively subsidized by the treasury economics of a stablecoin program."}</_components.p>{"\n"}<_components.h2>{"EIP-4844: proto-danksharding"}</_components.h2>{"\n"}<_components.p>{"Following the "}<ExternalLink title="Read more about the Dencun upgrade" href="https://cointelegraph.com/explained/what-is-the-ethereum-dencun-upgrade-and-why-is-it-important">{"Ethereum Dencun"}</ExternalLink>{" upgrade in March, improvements including EIP-4844 have dramatically reduced transactions fees in Ethereum Layer 2s with up to 95% fee reductions in Base, Optimism, and Arbitrum."}</_components.p>{"\n"}{}{"\n"}<_components.p><ExternalLink title="Read more about EIP-4844" href="https://eips.ethereum.org/EIPS/eip-4844">{"EIP-4844"}</ExternalLink>{" introduced a new transaction data type that allows for temporary\ndata storage called “blobs”. The latest data blobs bypass the traditional “call data”\nprocess to publish information on the Ethereum mainnet, providing faster transactions\nat lower fees."}</_components.p>{"\n"}<iframe className="w-full h-[500px] round border border-primary my-10 overflow-clip" src="https://dune.com/embeds/3924231/6597349?interval_days_e15077=180" />{"\n"}<_components.p>{"While Base, Arbitrum, and other layer two networks were already much cheaper than Ethereum mainnet, following EIP-4844 they have become ideal networks for payments at scale."}</_components.p>{"\n"}<_components.h2>{"What about the other fees?"}</_components.h2>{"\n"}<_components.p>{"Some of the feedback we received based on our "}<ExternalLink title="Read Costs to Transfer 1M" href="https://brale.xyz/blog/costs-to-transfer-1m-on-chain">{"previous blog"}</ExternalLink>{" comparing blockchain fees was two-fold. The first was that EIP-4844 would dramatically reduce costs further, which came true very quickly as described above. The other was the cost to effectively deposit or withdraw funds into a stablecoin. Below is the Brale fee schedule for on and offramps using onchain and offchain funding."}</_components.p>{"\n"}{}{"\n"}<div className="border border-primary round overflow-x-scroll bg-white dark:bg-black p-6 md:p-8 mt-8 mb-8"><table className="table-auto m-0 whitespace-nowrap"><thead><tr><th /><th className="px-4 text-wrap"><span className="whitespace-nowrap">{"Deposit Fee"}</span>{" (Onramp)"}</th><th className="px-4 text-wrap"><span className="whitespace-nowrap">{"Withdraw Fee"}</span>{" (Offramp)"}</th><th>{"Timing"}</th></tr></thead><tbody><tr><td><strong>{"Off-chain"}</strong></td></tr>{attributes.fees.offchain.map(f => <_components.tr key={f.type}>
          <_components.td>{f.type}</_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
          <_components.td>{f.timing}</_components.td>
        </_components.tr>)}<tr><td><strong>{"On-chain"}</strong></td></tr>{attributes.fees.onchain.map(f => <_components.tr key={f.type}>
          <_components.td>{f.type}</_components.td>
          <_components.td className="px-4">{f.depositFee}</_components.td>
          <_components.td className="px-4">{f.withdrawFee}</_components.td>
          <_components.td>{f.timing}</_components.td>
        </_components.tr>)}</tbody></table></div>{"\n"}<_components.p>{"Using a "}<ExternalLink title="Sign up for Brale Mint" href="https://app.brale.xyz/buy/signup/">{"Brale Mint"}</ExternalLink>{" account a business can effectively use stablecoins in its operations without the traditional onramp/offramp costs associated with using stablecoins."}</_components.p>{"\n"}<_components.p>{"We'd love to hear your feedback on these observations, and if there are additional blockchains you'd like to see supported. To support payments using your own stablecoin, sign up for an account."}</_components.p></>;
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? <MDXLayout {...props}><_createMdxContent {...props} /></MDXLayout> : _createMdxContent(props);
}
export default MDXContent;


export const filename = "costs-to-send-1m-on-leading-blockchains.mdx";
export const headers = typeof attributes !== "undefined" && attributes.headers;
export const meta = typeof attributes !== "undefined" && attributes.meta;
export const handle = typeof attributes !== "undefined" && attributes.handle;
    